import React from 'react';

export const FormRow = props => {
    return <div className={`row ${props.extraClass}`}>{props.children}</div>;
};


// WEBPACK FOOTER //
// ./src/customModules/Common/form/FormRow.js